import { Component, OnInit,ViewChild } from '@angular/core';
import { TopbarText } from "../../components/topbar/topbar.component";
import { global } from "../../modules/global";
import { AuthService } from "../../services/auth.service";
import { Tools } from "../../modules/tools";
import { ActivatedRoute } from '@angular/router';
import { __values } from 'tslib';
//import { RfidDetailComponent } from "../rfid-detail/community.component";
import { OperatorModel } from "src/app/models/operator.model";
import { HttpResponse, HttpEventType } from '@angular/common/http';
import {NgbModal, NgbActiveModal,NgbModalOptions} from "@ng-bootstrap/ng-bootstrap";
import {NgYesNoModalContent, NgInformationModalContent} from "../../util/components/modalcomponent/modal-content";
import { OperatorService } from "src/app/services/operator.service";
import { GSTLocationService } from "../../services/gstlocation.service"
import {GridPage,gridColumns,GridtableComponent} from "../../util/components/gridtable/gridtable.component";
import { GSTLocationModel } from "src/app/models/gstlocation.model";
import { GroupAddingModel } from "src/app/models/groupadding.model";
@Component({
  selector: 'app-add-screen',
  templateUrl: './add-screen.component.html',
  styleUrls: ['./add-screen.component.css']
})
export class AddScreenComponent implements OnInit {
  @ViewChild(GridtableComponent) gridComp: GridtableComponent;

  gridcols: gridColumns[] = [
    { columnHeader: "Sr", isSrCol: true, columnClasses: "c-col-pc-5 text-center" },
    {
      columnHeader: "GroupName",
      columnFieldName: "groupName",
      columnClasses: "c-col-pc-20 text-center"
    },{
      columnHeader: "Location",
      columnFieldName: "location",
      columnClasses: "c-col-pc-25 text-center"
    },  
    {
      columnHeader: "GenDate",
      columnFieldName: "genDate",
      columnClasses: "c-col-pc-30 text-center",
      callbackFunction: this.tools.defaultdateTimeFormat
    },
    {
      columnHeader: "Status",
      columnFieldName: "status",
      columnClasses: "c-col-pc-15 text-center",
      
    },
  ];
  searchField = {
    
    searchText: "",
    searchStatus:""
  };
  issaveon:boolean=false;
  page: GridPage;
  dateNow: Date = new Date();
  data: GroupAddingModel;
  _data: GroupAddingModel;
  _isSaved: boolean = false;
  datalist: Array<GSTLocationModel>;
  operator: OperatorModel;
  _action: string;
  isDetailScreen: boolean = false;
  //_disableSaveCancel: boolean = true;
 // isScreen: boolean = true;
 paramStatus: boolean = false;
  _menuId: string;
  topbartext: TopbarText[] = [{ key: "AddScreen", displayText: "Group Adding Screen" }];
 
  constructor(
    private route: ActivatedRoute,
    private ngbModalService: NgbModal,
    public tools: Tools,
    private objGlobal: global,
    private auth: AuthService,
    private gstlocationtservice: GSTLocationService) {  
      this.data = new GroupAddingModel();
      this.page = new GridPage();
      this.page.size = 10; 
      this._menuId = this.tools.getMenuName("main/AddScreen");
      this.objGlobal.setActiveMenu(this._menuId);
      this.getGroupaddingList();
      this.data.genDate=this.dateNow;
      if(!this.paramStatus){
        this.searchField.searchStatus="All";
       
        }}
       
  ngOnInit() {
    this.route.queryParams.filter(params => params.Status)
    .subscribe(params => {
     if(params.Status){
     this.paramStatus = true;
      this.searchField.searchStatus = params.Status;
      console.log(this.searchField.searchStatus ); 
      console.log(this.paramStatus); 
      this.getGroupaddingList();
     }
    }
  );
  }
  connectedDisconnected(event){
    console.log(event.target.value);
    this.searchField.searchStatus=event.target.value;
    this.getGroupaddingList();
  }
  gridDeleteButton() {
    return this.auth.isPrivExists(this._menuId + "=>delete");
  }
  inactiveGroupAdding(recObj: any) {
    const objStation: GroupAddingModel = recObj.obj;
    let ngmodaloptions: NgbModalOptions = {};
    ngmodaloptions.backdrop = "static";
    ngmodaloptions.size = "sm";
    const ngmodalref = this.ngbModalService.open(
      NgYesNoModalContent,
      ngmodaloptions
    );
    ngmodalref.componentInstance.title = "Confirmation";
    ngmodalref.componentInstance.message = "Are you sure to inactive Group?";
    ngmodalref.result.then(
      result => {
        if (result == "yes") {
          //console.log("test delete user");
          this.gstlocationtservice
            .inactiveGroupAdding(objStation.id)
            .subscribe(data => {
              if (data["success"]) {
                const modalRefOk = this.ngbModalService.open(
                  NgInformationModalContent,
                  ngmodaloptions
                );
                modalRefOk.componentInstance.title = "Information";
                modalRefOk.componentInstance.message =
                  "Group marked inactive successfully!";
                modalRefOk.componentInstance.btnCLass = "btn-info";
                modalRefOk.result.then(
                  result => {
                    this.getGroupaddingList();
                  },
                  reason => {
                    this.getGroupaddingList();
                  }
                );
              } else {
                alert("Failed to delete station!");
              }
            });
        }
      },
      reason => {}
    );
  }
  getGroupaddingList() {
    this.gstlocationtservice.getGroupAddinglist(this.page,this.searchField).subscribe(data => {
        // console.log(this.searchField);
         if (data["success"]) {
           this.datalist = data["result"].content;
           this.page.first = data["result"].first;
           this.page.last = data["result"].last;
           this.page.number = data["result"].number;
           this.page.numberOfElements = data["result"].numberOfElements;
           this.page.offset = data["result"].offset;
           this.page.size = data["result"].size;
           this.page.totalElements = data["result"].totalElements;
           this.page.totalPages = data["result"].totalPages;
           if (this.page.number == 0) {
             
           }
         } else {
           alert("Failed to get GSTLocationList!");
         }
       })
   }
   isAllowAddorEdit() {
     let isAllowSave = false;
     if (this._action == "new") {
       isAllowSave = this.auth.isPrivExists(this._menuId + "=>add");
     } else if (this._action == "update") {
       isAllowSave = this.auth.isPrivExists(this._menuId + "=>edit");
     }
     console.log(isAllowSave)
     return isAllowSave;
   }
   disableSave(f: any) {
     let isDisableSave: boolean = true;
     console.log(this.isModified());
     if (f.valid) {
       if (this.isModified()) {
         console.log(this.isAllowAddorEdit())
         if (this.isAllowAddorEdit()) {
           isDisableSave = false;
         }
       }
     }
     return isDisableSave;
   }
   onRowDblClick(locationvalue:any) {
    this._action = "update";
    this.isDetailScreen = true;
    //this.isScreen = false;
    //this.router.navigate(['user']);
    this.getDetail(locationvalue.id);
    this._data = this.tools.copyFullObject(this.data);
    this.issaveon=false
  }


  onBackClick() {
    if (this.isModified() == true) {
      let ngmodaloptions: NgbModalOptions = {};
      ngmodaloptions.backdrop = "static";
      ngmodaloptions.size = "sm";
      const ngmodalref = this.ngbModalService.open(
        NgYesNoModalContent,
        ngmodaloptions
      );
      ngmodalref.componentInstance.title = "Confirmation";
      ngmodalref.componentInstance.message =
        "Details has been modified. Are you sure to exit without save?";
      ngmodalref.result.then(
        result => {
          if (result == "yes") {
            this._action = "";
            this.isDetailScreen = false;
          }
        },
        reason => {}
      );
    } else {
      this._action = "";
      this.isDetailScreen = false;
    }
  }
  isModified() {
    if (!(this.data && this._data)) {
      return false;
    } else if (this.data.groupName != this._data.groupName) {
      return true;
    } else if (this.data.location!= this._data.location) {
      return true;
    } 
      return false;
  }
  isAllowAdd() {
    let isAdd = this.auth.isPrivExists(this._menuId + "=>add");
    return isAdd;
  }
  async onAddNew() {
    this.data = new GroupAddingModel();
    this._data = this.tools.copyFullObject(this.data);
    this._action = "new";
    this.data.genDate = this.dateNow;
    this.isDetailScreen = true;
    this.issaveon=true;
  }
  async getDetail(id) {
   if (id) {
      this.gstlocationtservice.getGroupAdding(id).subscribe(data => {
        if (data["success"]) {
          this.data = data["result"];
          this.data.genDate=new Date(this.data.genDate);
          this._data = this.tools.copyFullObject(this.data);
        }
      }
      )}
  }

  saveData() {
    console.log(this.data)
    this.gstlocationtservice.saveGroupAdding(this.data,this._action).subscribe(data => {
      let ngmodaloptions: NgbModalOptions = {};
      ngmodaloptions.backdrop = "static";
      ngmodaloptions.size = "sm";
      if (data["success"]) {
        this._isSaved = true;
        const modalRef = this.ngbModalService.open(
          NgInformationModalContent,
          ngmodaloptions
        );
        modalRef.componentInstance.title = "Information";
        modalRef.componentInstance.message = "saved successfully!";
        modalRef.componentInstance.btnCLass = "btn-info";
        modalRef.result.then(
          result => {
            this.data = data["result"];
            this._data = this.tools.copyFullObject(this.data);
            if (result == "ok") {
              if (result == "ok") {
               this.getGroupaddingList();
                this.isDetailScreen = false;
              }
              this.isDetailScreen = false;
            }
          },
          reason => {
            this.data = data["result"];
            this._data = this.tools.copyFullObject(this.data);
          }
        );
      } 
      
      else {
        const modalRef = this.ngbModalService.open(
          NgInformationModalContent,
          ngmodaloptions
        );
        modalRef.componentInstance.title = "Error";
        modalRef.componentInstance.message = "Failed to save !";
        modalRef.componentInstance.btnCLass = "btn-warning";
        modalRef.result.then(
          result => {},
          reason => {}
        );
        // alert("station not saved");
      }
    });
  }


}
